const caches = {};

class Cache {
  /**
   * Set cache data for a specific action and key
   * @param {string} actionName - The action/namespace for the cache
   * @param {string} key - The key to store the data under
   * @param {any} value - The value to cache
   */
  setCache(actionName, key, value) {
    if (!caches[actionName]) caches[actionName] = {};
    caches[actionName][key] = value;
  }

  /**
   * Get cache data for a specific action and key
   * @param {string} actionName - The action/namespace for the cache
   * @param {string} key - The key to retrieve data for
   * @returns {any} The cached data or undefined if not found
   */
  getCache(actionName, key) {
    const cache = caches[actionName];
    return cache && key !== undefined ? cache[key] : cache;
  }

  /**
   * Clear all cache data for a specific action
   * @param {string} actionName - The action/namespace to clear
   */
  clearCache(actionName) {
    caches[actionName] = undefined;
  }

  /**
   * Clear all caches
   */
  clearAllCaches() {
    Object.keys(caches).forEach((actionName) => {
      caches[actionName] = undefined;
    });
  }

  /**
   * Check if cache exists for a specific action and key
   * @param {string} actionName - The action/namespace
   * @param {string} key - The key to check
   * @returns {boolean} True if cache exists
   */
  hasCache(actionName, key) {
    const cache = caches[actionName];
    return cache && key !== undefined
      ? Object.prototype.hasOwnProperty.call(cache, key) // ✅ fixed
      : !!cache;
  }

  /**
   * Get all cache keys for a specific action
   * @param {string} actionName - The action/namespace
   * @returns {string[]} Array of cache keys
   */
  getCacheKeys(actionName) {
    const cache = caches[actionName];
    return cache ? Object.keys(cache) : [];
  }
}

export default new Cache();
